export const RECEPTIONIST_FIELDS = {
  id: 'id',
  fullName: 'fullName',
  email: 'email',
  profileStatus: 'profileStatus',
  sendNotifications: 'sendNotifications',
};
